import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import { EMPLOYMENT_PROFILES_ENDPOINT } from '../config'
import {
  EmploymentProfileDto,
  UpsertEmploymentProfileDto
} from './EmploymentProfilesAPI.model'

/**
 * REST client for employment profiles. Paths are prefixed with
 * `/restaurants/{restaurantId}` by HTTPInstanceWithPrefix, which is what scopes
 * a profile to one venue: the same person working two restaurants has two
 * profiles and one identity.
 */
class EmploymentProfilesAPI {
  /**
   * GET every stored profile.
   *
   * Only rows that exist come back. An employee who has never been given
   * employment data is simply absent from the array, that is "no profile
   * yet", not an error.
   */
  static getProfiles = (): Promise<EmploymentProfileDto[]> =>
    HTTPInstanceWithPrefix.get(EMPLOYMENT_PROFILES_ENDPOINT).then(
      response => response.data
    )

  /**
   * PUT one profile, creating it if it does not exist. The body replaces the
   * stored row whole, every field absent from it is wiped, never preserved.
   *
   * 403s when `userId` is not a member of the restaurant, so on the create
   * flow this must run after the employee has been registered.
   */
  static upsertProfile = (
    userId: string,
    payload: UpsertEmploymentProfileDto
  ): Promise<EmploymentProfileDto> =>
    HTTPInstanceWithPrefix.put(
      `${EMPLOYMENT_PROFILES_ENDPOINT}/${userId}`,
      payload
    ).then(response => response.data)

  /** DELETE the profile. 404s when there is none, check before calling. */
  static deleteProfile = (userId: string): Promise<void> =>
    HTTPInstanceWithPrefix.delete(
      `${EMPLOYMENT_PROFILES_ENDPOINT}/${userId}`
    ).then(response => response.data)
}

export default EmploymentProfilesAPI
